export default "__VITE_ASSET__CBe123sE__"